export const GET_RETURN_VOUCHERS = 'GET_RETURN_VOUCHERS';
export const GET_RETURN_VOUCHERS_SUCCESS = 'GET_RETURN_VOUCHERS_SUCCESS';
export const GET_RETURN_VOUCHERS_FAILURE = 'GET_RETURN_VOUCHERS_FAILURE';

export const getReturnVouchers = params => ({
  type: GET_RETURN_VOUCHERS,
  payload: params
});

export const GET_RETURN_VOUCHER = 'GET_RETURN_VOUCHER';
export const GET_RETURN_VOUCHER_SUCCESS = 'GET_RETURN_VOUCHER_SUCCESS';
export const GET_RETURN_VOUCHER_FAILURE = 'GET_RETURN_VOUCHER_FAILURE';

export const getReturnVoucher = returnVoucherId => ({
  type: GET_RETURN_VOUCHER,
  payload: returnVoucherId
});

export const OPEN_RETURN_VOUCHER_DRAWER = 'OPEN_RETURN_VOUCHER_DRAWER';
export const openDrawer = () => ({ type: OPEN_RETURN_VOUCHER_DRAWER });

export const CLOSE_RETURN_VOUCHER_DRAWER = 'CLOSE_RETURN_VOUCHER_DRAWER';
export const closeDrawer = () => ({ type: CLOSE_RETURN_VOUCHER_DRAWER });

export const CANCEL_RETURN_VOUCHER = 'CANCEL_RETURN_VOUCHER';
export const CANCEL_RETURN_VOUCHER_SUCCESS = 'CANCEL_RETURN_VOUCHER_SUCCESS';
export const cancelReturnVoucher = returnVoucherId => ({
  type: CANCEL_RETURN_VOUCHER,
  payload: returnVoucherId
});

export const UPDATE_RETURN_VOUCHER = 'UPDATE_RETURN_VOUCHER';
export const UPDATE_RETURN_VOUCHER_SUCCESS = 'UPDATE_RETURN_VOUCHER_SUCCESS';
export const updateReturnVoucher = data => ({
  type: UPDATE_RETURN_VOUCHER,
  payload: data
});
